import { render } from "./ArrearsRecoveriesCases.vue?vue&type=template&id=2d2f6f7f&scoped=true"
import script from "./ArrearsRecoveriesCases.vue?vue&type=script&lang=js"
export * from "./ArrearsRecoveriesCases.vue?vue&type=script&lang=js"

import "./ArrearsRecoveriesCases.vue?vue&type=style&index=0&id=2d2f6f7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2f6f7f"]])

export default __exports__